<template>
<div ref="EditRecord">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑记录</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="recordlist.length > 1 ? recordlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回记录类型</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in recordlist" :key="index">
            <div class="TTL-form-submit-box-title">记录-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="deltype(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">选择宠物</label>
                    <div class="TTL-select">
                    <el-select v-model="item.petid" placeholder="请选择宠物" filterable clearable>
                    <el-option v-for="(pet,i) in item.petlist" :key="i" :label="pet.name" :value="pet.id" />
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">选择类型</label>
                    <div class="TTL-select">
                    <el-select v-model="item.typeid" placeholder="请选择记录类型" filterable clearable @change="changeType(index)">
                    <el-option v-for="(type,i) in typelist" :key="i" :label="type.typename" :value="type.id" />
                    </el-select>
                    </div>
                    <div class="TTL-image-box-middle" v-if="item.typeicon">
                    <el-image :src="item.typeicon" fit="cover" />
                    </div>
                </el-form-item>



                <!-- 体重 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==5">
                    <div class="TTL-input TTL-append TTL-form-input">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写体重" clearable>
                    <template #append>kg</template>
                    </el-input>
                    </div>
                </el-form-item>

                <!-- 饮食 -->
                <el-form-item v-if="item.typeid==7">
                    <div v-for="(detail,i) in item.detail" :key="i" style="display:inline-flex;width:100%;margin-bottom:20px">
                        <div class="TTL-select marginright20">
                        <el-select v-model="detail.selectvalue1" placeholder="请选择食物类型" filterable clearable>
                        <el-option v-for="(food,ii) in foodlists" :key="ii" :label="food.name" :value="food.id" />
                        </el-select>
                        </div>
                        <div class="TTL-input TTL-form-input width200 marginright20">
                        <el-input v-model="detail.inputvalue1" placeholder="请填写食物名称" clearable />
                        </div>
                        <div class="TTL-input TTL-form-input marginright20">
                        <el-input v-model="detail.inputvalue2" placeholder="请填写食物量" clearable />
                        </div>
                        <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                        <el-button @click="AddRecordProgram(index)">新增</el-button>
                        </div>
                        <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                        <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                        </div>
                    </div>
                </el-form-item>

                <!-- 喝水 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==8">
                    <div class="TTL-input TTL-append TTL-form-input">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写喝水量" clearable>
                    <template #append>ml</template>
                    </el-input>
                    </div>
                </el-form-item>

                <!-- 记账 -->
                <el-form-item v-if="item.typeid==9">
                    <div v-for="(detail,i) in item.detail" :key="i" style="display:inline-flex;width:100%;margin-bottom:20px">
                        <div class="TTL-select marginright20">
                        <el-cascader v-model="detail.selectvalue1" :options="cashierlists" />
                        </div>
                        <div class="TTL-input TTL-append TTL-form-input">
                        <el-input v-model="detail.inputvalue1" placeholder="请填写金额" clearable>
                        <template #append>元</template>
                        </el-input>
                        </div>
                    </div>
                </el-form-item>

                <!-- 喂保健品 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==10">
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写保健品名称" clearable />
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue2" placeholder="请填写保健品进食量" clearable />
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 异常 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==11">
                    <div class="TTL-select marginright20">
                    <el-select v-model="detail.selectvalue1" placeholder="请选择异常类型" filterable clearable>
                    <el-option v-for="(special,ii) in speciallists" :key="ii" :label="special.name" :value="special.id" />
                    </el-select>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 驱虫类型 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==12">
                    <div class="TTL-select marginright20">
                    <el-select v-model="detail.selectvalue1" placeholder="请选择驱虫类型" filterable clearable>
                    <el-option v-for="(special,ii) in Insecticidalliist" :key="ii" :label="special.name" :value="special.id" />
                    </el-select>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 疫苗 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==13">
                    <div class="TTL-select marginright20">
                    <el-select v-model="detail.selectvalue1" placeholder="请选择疫苗类型" filterable clearable>
                    <el-option v-for="(vacc,ii) in vaccinlists" :key="ii" :label="vacc.name" :value="vacc.id" />
                    </el-select>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 抗体水平 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==14">
                    <div class="TTL-select marginright20">
                    <el-select v-model="detail.selectvalue1" placeholder="请选择检测项目" filterable clearable>
                    <el-option v-for="(ant,ii) in antibodylists" :key="ii" :label="ant.name" :value="ant.id" />
                    </el-select>
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写检测数值" clearable />
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 体检/看病/住院 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==15 || item.typeid==16 || item.typeid==18">
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写就诊医院" clearable />
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue2" placeholder="请填写主治医生" clearable />
                    </div>
                </el-form-item>

                <!-- 给药方式 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==17">
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写药品名称" clearable />
                    </div>
                    <div class="TTL-select marginright20">
                    <el-select v-model="detail.selectvalue1" placeholder="请选择给药方式" filterable clearable>
                    <el-option v-for="(drug,ii) in druglists" :key="ii" :label="drug.name" :value="drug.id" />
                    </el-select>
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue2" placeholder="请填写给药剂量" clearable />
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i==0">
                    <el-button @click="AddRecordProgram(index)">新增</el-button>
                    </div>
                    <div class="TTL-button TTL-btn-option marginright20" v-if="i > 0">
                    <el-button type="del" @click="DelRecordProgram(index,i)">删除</el-button>
                    </div>
                </el-form-item>

                <!-- 手术 -->
                <el-form-item v-for="(detail,i) in item.detail" :key="i" v-if="item.typeid==19">
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue1" placeholder="请填写就诊医院" clearable />
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue2" placeholder="请填写主治医生" clearable />
                    </div>
                    <div class="TTL-input TTL-form-input width200 marginright20">
                    <el-input v-model="detail.inputvalue3" placeholder="请填写手术类型" clearable />
                    </div>
                </el-form-item>


                <el-form-item>
                    <label class="TTL-form-label">描述</label>
                    <div class="TTL-input">
                    <el-input type="textarea" v-model="item.content" class="width350" :autosize="{ minRows: 6, maxRows: 8}" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">记录时间</label>
                    <div class="TTL-datetime">
                    <el-date-picker v-model="item.recordtime" type="date" value-format="YYYY-MM-DD" placeholder="请选择记录时间" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">上传图片/视频</label>
                    <div class="TTL-image-box-large" @click.stop="uploadimages(index)">
                        <el-image :src="require('@/assets/icon/add-default.png')" fit="cover" />
                    </div>
                    <div class="TTL-image-box-large" v-for="(file,i) in item.file" :key="i">
                        <a class="TTL-image-del" @click.stop="delfiles(index,i)"></a>
                        <el-image :src="file" fit="cover" />
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Member/Member';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_RECORD from '@/Interface/Record/Record';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 5,          //单次新增限制
            uploadimageIndex:'',  //获取当前上传图片的序号
            changeSelectIndex:'', //会员选择序号
            typelist:[],          //类型信息
            memberlist:[],        //会员信息
            petlist:[],           //宠物信息
            foodlists:[],         //食物信息列表
            cashierlists:[],      //记账类型
            speciallists:[],      //异常类型
            Insecticidalliist:[], //驱虫类型
            vaccinlists:[],       //疫苗类型
            antibodylists:[],     //抗体类型
            druglists:[],         //药品类型
            recordlist:[
                {ptypeid:'',typeid:'',typeicon:'',memberid:'',petid:'',recordtime:'',content:'',memberlist:[],petlist:[],file:[],detail:[]},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.ParseDataFromBrowser();   //解析之前填写的数据
            this.GetRecordTypelist();      //获取记录类型信息
            this.GetRecordOtherTypelist(); //获取记录类型其它分类类型信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有数据正在进行编辑，执行该操作会覆盖正在进行编辑的数据，是否执行 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetRecordInfos(data.ids); //获取记录信息详情
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser();
            }else {
                this.GetRecordInfos(data.ids); //获取记录信息详情
            }
        },


        /** 提交数据 **/
        submitData() {
            var data=[];
            var records={};
            for(var i=0;i<this.recordlist.length;i++) {
                records=this.recordlist[i];
                data.push({
                    id:records.id,ptypeid:records.ptypeid,typeid:records.typeid,memberid:records.memberid,
                    petid:records.petid,recordtime:records.recordtime,content:records.content,
                    file:records.file,detail:records.detail
                });
            }
            
            data=JSON.stringify(data);
            var loadingobj=this.$refs.EditRecord;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_RECORD.EDIT_RECORD({recorddata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.GoBackPets(true);
            });
        },


        /** 获取记录信息详情 **/
        GetRecordInfos(ids) {
            var obj;
            var loadingobj=this.$refs.EditRecord;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_RECORD.GET_RECORD_INFOS({ids:ids}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.recordlist=[];
                this.recordlist=res.data;
                console.log(this.recordlist);

                //填充各级的会员列表、宠物列表
                for(var i=0;i <  this.recordlist.length; i++) {
                    obj=this.recordlist[i];
                    this.GetMemberLists(obj.username,i); //获取会员信息列表
                    this.getPetInfos(obj.memberid,i);  //填充宠物信息
                }
            });
        },


        /** 删除单个品种信息 **/
        deltype(index) {
            this.recordlist.splice(index,1);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 重置加载数据 **/
        resetParam() {
            var data={ptypeid:'',typeid:'',typeicon:'',memberid:'',petid:'',recordtime:'',content:'',memberlist:[],petlist:[],file:[],detail:[]};
            this.recordlist=[data];
        },


        /** 上传图片信息 **/
        uploadimages(index) {
            this.uploadimageIndex=index;                          //标记当前上传图片序号
            var obj=document.querySelector('#TTLFilesmore');          //获取文件对象
            obj.click();                                          //点击触发上传图片
            obj.addEventListener('change',this.uploadimagedata);  //添加监听事件
        },


        /** 上传图片信息操作 **/
        uploadimagedata(e) {
            this.filelist=e.srcElement.files;   //获取上传的图片
            document.querySelector('#TTLFilesmore').removeEventListener('change',this.uploadimagedata);  //解除监听事件

            var file='';
            var sort=0;
            for(var i=0;i< this.filelist.length;i++) {
                sort++;
                file=this.filelist[i];
                 //上传图片到接口操作
                INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:'normal',File:file}).then((res) => {
                    if(res.status > 0) return false;
                    this.recordlist[this.uploadimageIndex].file.push(this.$ImageAddress+res.data.url);
                    this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                    if(sort==this.filelist.length) e.srcElement.value=null;  //清空数据
                });
            }
        },


        /** 删除图片信息 **/
        delfiles(index,i) {
            this.recordlist[index].file.splice(i,1);
        },


        /** 切换记录类型信息 **/
        changeType(index) {
            var typeid=this.recordlist[index].typeid;
            if(!typeid || typeid=='') {this.recordlist[index].typeicon='';return false;}
            for(var i=0;i<this.typelist.length;i++) {
                if(typeid==this.typelist[i].id) this.recordlist[index].typeicon=this.typelist[i].icon;
            }

            //加载默认详情信息
            this.AddDefaultDetail(index,typeid);
        },

        //加载详情信息
        AddDefaultDetail(index,typeid) {
            this.recordlist[index].detail=[];
            var param={inputvalue1:'',inputvalue2:'',inputvalue3:'',selectvalue1:'',selectvalue2:'',selectvalue3:''};
            this.recordlist[index].detail.push(param)
        },

        //新增记录项目
        AddRecordProgram(index) {
            var param={inputvalue1:'',inputvalue2:'',inputvalue3:'',selectvalue1:'',selectvalue2:'',selectvalue3:''};
            this.recordlist[index].detail.push(param);
        },

        //删除记录项目
        DelRecordProgram(index,i) {
            this.recordlist[index].detail.splice(i,1);
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取其它类型分类信息 **/
        GetRecordOtherTypelist() {
            INTERFACE_MODEL_RECORD.GET_RECORD_OTHER_TYPE({}).then((res) => {
                if(res.status > 0) return false;
                var data=res.data;
                this.foodlists=data.food;
                this.cashierlists=data.cashier;
                this.speciallists=data.special;
                this.Insecticidalliist=data.Insecticidal;
                this.vaccinlists=data.vaccin;
                this.antibodylists=data.antibody;
                this.druglists=data.drug;
            });
        },


        /** 获取记录类型信息 **/
        GetRecordTypelist() {
            this.typelist=[];
            INTERFACE_MODEL_RECORD.GET_RECORD_TYPE_LIST({}).then((res) => {
                if(res.status > 0) return false;
                var result=res.data.list;
                var childtypes;
                for(var i=0;i < result.length;i++) {
                    childtypes=result[i].child;
                    for(var ii=0;ii < childtypes.length;ii++)
                    this.typelist.push({id:childtypes[ii].id,pid:childtypes[ii].parentid,typename:childtypes[ii].typename,icon:childtypes[ii].icon});
                }
            });
        },


        /** 关键字搜索会员信息 **/
        GetMemberLists(keyname,i=-1) {
            if(!keyname || keyname=='') return false; //传入空字符串时不执行搜索

            var param={key:keyname,p:1,rollpage:1000000};
            INTERFACE_MODEL_MEMBER.GET_MEMBER_INFO(param).then((res) => {
                 if(res.status > 0) return false;
                 var result=res.data.list;
                 var localindex=i >=0 ? i : this.changeSelectIndex;

                 this.recordlist[localindex].memberlist=result.map(item => {
                     return {id:item.id,name:item.username+'-'+item.phone,pet:item.pet}
                 });
            });
        },

        
        /** 切换会员信息 **/
        changeMember(index) {
            var memberid=this.recordlist[index].memberid;
            this.recordlist[index].petid='';
            this.getPetInfos(memberid,index);
        },


        /** 获取宠物信息 **/
        getPetInfos(memberid,index) {
            var param={memberids:memberid,p:1,rollpage:1000000};
            INTERFACE_MODEL_PETS.GET_PET_INFO_LIST(param).then((res) => {
                 if(res.status > 0) return false;
                 var result=res.data.list;
                 var _this=this;
                 _this.recordlist[index].petlist=result.map(item => {
                     return {id:item.id,name:item.name};
                 });
            });
        },


        /** 标记当前正在选择的会员 **/
        changeSelect(index) {
            this.changeSelectIndex=index;
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.recordlist);
            localStorage.setItem('EditRecorddata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('EditRecorddata');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.recordlist=[{ptypeid:'',typeid:'',typeicon:'',memberid:'',petid:'',recordtime:'',content:'',memberlist:[],petlist:[],file:[],detail:[]}] : 
            this.recordlist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'宠物记录',labelentry:'Record',components:'Record',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditRecord';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;margin:0 20px 0 0;position: relative;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-image-del {
    position: absolute;
    top:0;
    right:0;
    margin-top:-12.5px;
    margin-right:-12.5px;
    width:25px;
    height:25px;
    border-radius:50%;
    z-index:1;
    background-image: url(@/assets/icon/close-blue.png);
    background-repeat: no-repeat;
    background-size: 25px;
    background-position: center;
}
.TTL-image-box-middle .el-image {width:80px;height:80px;border-radius:50%;margin-left:20px;}
</style>